// extracted by css-extract-rspack-plugin
export default {"ViewSidebarAside":"fAGIR","rightSide":"SzaO8","isOpen":"B3fkf","leftSide":"i8roT"};